<template>
    <div class="flex flex-col border-b border-gray-separator | md:py-1">
        
        <div
            class="flex flex-row flex-wrap w-full items-center transition-opacity align-baseline "
            :class="{ 'opacity-50' : disabled }"
        >
            <div class="w-3/4 flex items-center order-1 | md:w-auto">
                <div class="text-3xl p-2 "> +</div>
                <div class="flex items-center text-sm font-bold w-48 p-2 ">
                    <span>{{ field.getFieldLabel() }}</span>
                    <button class="md:hidden px-2 underline text-gold-light" @click="showModalDescription = true">
                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19.5C7.86 19.5 4.5 16.14 4.5 12C4.5 7.86 7.86 4.5 12 4.5C16.14 4.5 19.5 7.86 19.5 12C19.5 16.14 16.14 19.5 12 19.5ZM14.3 7.7C14.91 8.31 15.25 9.13 15.25 10C15.25 10.87 14.91 11.68 14.3 12.3C13.87 12.73 13.33 13.03 12.75 13.16V13.5C12.75 13.91 12.41 14.25 12 14.25C11.59 14.25 11.25 13.91 11.25 13.5V12.5C11.25 12.09 11.59 11.75 12 11.75C12.47 11.75 12.91 11.57 13.24 11.24C13.57 10.91 13.75 10.47 13.75 10C13.75 9.53 13.57 9.09 13.24 8.76C12.58 8.1 11.43 8.1 10.77 8.76C10.44 9.09 10.26 9.53 10.26 10C10.26 10.41 9.92 10.75 9.51 10.75C9.1 10.75 8.76 10.41 8.76 10C8.76 9.13 9.1 8.32 9.71 7.7C10.94 6.47 13.08 6.47 14.31 7.7H14.3ZM13 16.25C13 16.8 12.55 17.25 12 17.25C11.45 17.25 11 16.8 11 16.25C11 15.7 11.45 15.25 12 15.25C12.55 15.25 13 15.7 13 16.25Z" fill="#000000"/>
                        </svg>
                    </button>
                </div>
                
            </div>

            <div class="w-full order-3 | md:order-2 md:w-auto md:flex-1">
                <select
                    v-if="showSelect"
                    class="block w-full cursor-pointer border-2 border-gray-light shadow-sm text-sm bg-gray text-gray-700 py-2 px-4 pr-8 focus:outline-none focus:border-gray-500"
                    :value="selecting"
                    @change="changed"
                    :disabled="disabled"
                    placehoolder="Choose an option"
                >
                    <option disabled hidden :value="null">Choose an option</option>
                    <option
                        v-for="(field,index) in getVisibleFields(field.options)"
                        :value="index"
                        :key="`field-options-${index}`"
                    >{{ field.label }} - £{{ field.getPricePerType() }} {{ field.getTypeLabel() }}
                    </option>
                </select>
                <div v-else>
                    <div class="text-right text-sm text-gray-light">
                        {{ selected.label }} <template v-if="selectedPrice">(£{{ selectedPrice }})</template>
                    </div>
                </div>
            </div>
            
            <div class="flex align-center justify-end w-1/4 text-xs order-2 | md:px-2 md:justify-start md:w-10 md:order-last">
              
                <button v-if="showEdit" class="underline text-orange" @click="editField">edit</button>
            </div>
            
        </div>
        <slide-up-down :active="showDescription" :duration="1000">
            <FiledOptionsDescriptions :field="field"/>
        </slide-up-down>
        <ModalFiledOptionsDescriptions
            :field="field"
            :show="showModalDescription"
            @close-modal="showModalDescription = false"
        />

    </div>

</template>

<script>
import SlideUpDown from 'vue-slide-up-down'
import PriceCalculator from "../../../_controllers/PriceCalculator";
import FiledOptionsDescriptions from "../FiledOptionsDescriptions";
import ModalFiledOptionsDescriptions from "../ModalFiledOptionsDescriptions.vue";

export default {
    name: "ProductField",
    components: { ModalFiledOptionsDescriptions, SlideUpDown, FiledOptionsDescriptions },
    props: {
        field: {},
        sizes: {},
        fieldDisplayPrice: 0,
        showMinPrice: { 
            default: false,  
        } ,
        selected: {
            default: null
        },
        disabled: {
            default: true
        },
        fieldUpdated: {
            type: Function,
            default: () => {}
        },
        conditionController: {}
    },
    data() {
        return {
            edit: false,
            selecting: this.selected,
            showModalDescription: false,
        }
    },
    computed: {
        showDescription() {
            return !this.disabled && !this.field.selectedOption
        },
        showSelect() {
            return !this.field.selectedOption || this.edit
        },
        showEdit() {
            return !!(!this.edit && this.field.selectedOption)
        },
        selectedPrice() {
            
            if (!this.selected) {
                return ''
            }
            
            if (!this.showMinPrice){
                return '';
            }
            
            if( this.fieldDisplayPrice <= 0 ){
                return false;
            }
            
            return this.fieldDisplayPrice;//PriceCalculator.roundUp(this.selected.getPrice(this.sizes), 2).toFixed(2)
        }
    },
    methods: {
        changed(e) {
            e?.target ? this.field.selectedOption = this.getVisibleFields(this.field.options)[e.target.value] : null;
            
            this.edit = false;
            this.field.mapToForm = this.mapToForm();
            this.fieldUpdated();
        },
        getVisibleFields(fields) {
            return fields.filter(field => {
                return this.conditionController.isFieldOptionShouldBeDisplayed(field);
            });
        },
        editField() {
            this.edit = true;
            this.selecting = null;
            this.field.selectedOption = false;
            this.field.mapToForm = this.mapToForm();
            // this.fieldUpdated();
        },
        mapToForm() {
            return {
                id: this.field.id,
                name: this.field.name,
                label: this.field.label,
                selected: this.field.selectedOption
            }
        },
    },
}
</script>